export function Analytics() {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Analytics</h2>
      <p className="text-gray-600">Platform-wide analytics — to be implemented in Phase 5.</p>
    </div>
  );
}